import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { getActiveContentTab, lazyActivateTab, primaryTab, TabType } from 'owa-tab-store';

/**
 * When a secondary reading pane tab is active and the user right-clicks an already-selected
 * mail list row, the normal selection-change path is skipped (no re-selection needed), so the
 * SRP tab deactivation that is a side effect of that path never fires. This function replicates
 * just that side effect so the context menu evaluates folder-based action availability against
 * the mail list's current folder rather than the SRP item's origin folder.
 */
export function deactivateSRPForContextMenu(): void {
    if (isGlobalFeatureEnabled('mon-ribbon-secondary-rp-activation')) {
        const activeTab = getActiveContentTab();
        if (activeTab?.type === TabType.SecondaryReadingPane) {
            lazyActivateTab.importAndExecute(primaryTab);
        }
    }
}
